export default __webpack_public_path__ + "static/media/pexels-mohammad-danish-891059.a496d8c7.jpg";